import * as momentTimezone from 'moment-timezone';
import React from 'react';
import History from '../../History';
import { Tooltip, IconButton } from '@material-ui/core';
import { ArrowBack } from '@material-ui/icons';
import store from '../../store';
import { getDateFormat } from "./date";

export const formatDate = date => {
    if (date) {
        const customerTimezone = window.localStorage.getItem("CustomerTimezone") ?? 'UTC';

        return momentTimezone.utc(date)?.tz(customerTimezone)?.format(`${getDateFormat()} HH:mm:ss z`);
    }
    return '';
}

export const queryTypes = [{ Name: 'Products All', value: 'ProductsAll', label: 'products_all' }, { Name: 'ProductsMinimal', value: 'ProductsMinimal', label: 'products_minimal' }];

export const objectDeepClean = objectToClean => {
    if (typeof objectToClean === 'object' && objectToClean !== null && !(objectToClean instanceof Array)) {
        for (let key in objectToClean) {
            // Check if value is object (not null and not array)
            if (typeof objectToClean[key] === 'object' && objectToClean[key] !== null && !(objectToClean[key] instanceof Array)) {
                objectDeepClean(objectToClean[key]);
                // After deep cleaning, check if object is empty
                if (Object.keys(objectToClean[key]).length === 0) {
                    delete objectToClean[key];
                }
                continue;
            }

            // Check if value is an array, if its array and length is 0 deletes key from object, otherwise pass further
            if (objectToClean[key] instanceof Array && objectToClean[key].length === 0) {
                delete objectToClean[key];
                continue;
            }

            // If value is different than null|undefined|"" its okay we can proceed to the next value, otherwise deletes key from object
            if (objectToClean[key] !== null && objectToClean[key] !== undefined && objectToClean[key] !== "") {
                continue;
            }

            // If value is number and is valid continue, otherwise delete it
            if (typeof objectToClean[key] === 'number' && !isNaN(objectToClean[key])) {
                continue;
            }

            delete objectToClean[key];
        }
    }

    return objectToClean;
}
export const chassisType = translations => {

    return [{ key: 'PC', value: translations['pc'] || 'PC' },
    { key: 'Server', value: translations['server'] || 'Server' },
    { key: 'Display', value: translations['display'] || 'Display' },
    { key: 'Notebook', value: translations['notebook'] || 'Notebook' },
    { key: 'Mobile', value: translations['mobile'] || 'Mobile' }];
}
export const erasureReportType = translations => {
    return {
        lookup: {
            'pdf': translations['pdf'] || 'PDF',
            'component': translations['component'] || 'Component',
            'bulk': translations['bulk'] || 'Bulk',
            'PO-bulk': translations['po_bulk'] || 'PO-bulk',
            'PO-storages': translations['po_storages'] || 'PO-storages',
            'file_system_nodes': translations['file_system_report'] || 'File system report'
        },
        defaultFilter: ['pdf', 'component', 'bulk', 'PO-storages', 'PO-bulk', 'IP-bulk', 'file_system_nodes'],
    }
}

export const workDiagnoseReportType = translations => {
    return {
        lookup: {
            'pdf': translations['pdf'] || 'PDF',
            'component': translations['component'] || 'Component',
        },
        defaultFilter: ['pdf', 'component'],
    }
}

export const hasPermission = (userPermissions, permission) => {
    return userPermissions?.includes("*") || userPermissions?.includes(permission);
};

export const getDimensionsOfPagination = count => {
    if (!count || count <= 50) {
        return { pageSize: 20, rowsPageSize: [20, 50] }
    }
    return { pageSize: 50, rowsPageSize: [20, 50, 100] }
};

export const hasAtLeastOnePermission = (userPermissions, requiredPermissions) => {
    return userPermissions.includes('*') || requiredPermissions.some(requiredPermission => userPermissions.includes(requiredPermission));
};
export const isSuperUser = () => {
    const state = store.getState();
    let permissions = state.core.login.permissions ? state.core.login.permissions : []
    return permissions.includes('*');
}

export const hasExternalSettingsAvailable = () => {
    const state = store.getState();
    let externalSettings = state.core.login.activeExternalServiceAvailable ? state.core.login.activeExternalServiceAvailable : false
    return externalSettings;
}

export const getProductData = (data, field, from = null) => {
    if (from) {
        switch (field.toLowerCase()) {
            case 'model':
                if (data.Product.Type === 'PCProduct') {
                    return data.Product['PCProduct'] ? data.Product['PCProduct'].Name : '';
                }
                if (data.Product.Type === 'MobileProduct') {
                    return data.Product['MobileProduct'] ? data.Product['MobileProduct'].MobileProductModel : '';
                }
                break;
            default:
                return data.Product[data.Product.Type][field];
        }
    }

    return data.Product[field];
}

export const getPrinterData = (data, field, from = null) => {
    if (from) {
        return data[from].Printer ? data[from].Printer[field] ? data[from].Printer[field] : '' : '';
    }
    return data.Printer ? data.Printer[field] ? data.Printer[field] : '' : '';
}

export const getPrintStatus = status => {
    switch (status) {
        case -2:
            return 'Failed';
        case -1:
            return 'Printing';
        case 0:
            return 'Printed';
        case 1:
            return 'Pending';
        default:
            return 'Failed';
    }
}

export const localization = (translations) => {
    return {
        pagination: {
            labelDisplayedRows: translations["from_to_of_count"] || '{from}-{to} of {count}',
            firstTooltip: translations['first_page'] || "First page",
            previousTooltip: translations['previous_page'] || "Previous page",
            nextTooltip: translations['next_page'] || "Next page",
            lastTooltip: translations['last_page'] || "Last page",
            labelRowsSelect: translations['rows'] || 'rows',

        },
        toolbar: {
            showColumnsTitle: translations["show_columns"] || 'SHOW COLUMNS',
            exportTitle: translations["export"] || 'EXPORT',
            showColumnsAriaLabel: translations["show_columns"] || 'SHOW COLUMNS',
            addRemoveColumns: translations["add_or_remove"] || 'Add or remove columns',
            exportName: translations["export_as_csv"] || "Export as CSV"
        },
        body: {
            emptyDataSourceMessage: translations['table_no_match'] || "Sorry, no matching records found",
            filterRow: {
                filterTooltip: translations["filter"] || 'Filter'
            },
            deleteTooltip: translations["delete"] || "Delete",
            editTooltip: translations["edit"] || "Edit"
        },
        header: {
            actions: translations["actions"] || 'Action(s)'
        },
    }
}

export const getErasureReportStatus = (...data) => {
    if (typeof data[1] !== 'undefined' && data[1] === 'forStyle') {
        switch (data[0]) {
            case -1:
                return 'Failed';
            case 0:
                return 'Ready';
            case 1:
                return 'InProgress';
            case 2:
                return 'Generated';
            default:
                return 'Failed';
        }
    }

    if (data[1] === null && data[2] === null) {
        switch (data[0]) {
            case -1:
                return `${data[3]['failed'] ? data[3]['failed'] : 'Failed'}`;
            case 0:
                return `${data[3]['ready'] ? data[3]['ready'] : 'Ready'}`;
            case 1:
                return `${data[3]['in_progress'] ? data[3]['in_progress'] : 'In progress'}`;
            case 2:
                return `${data[3]['generated'] ? data[3]['generated'] : 'Generated'}`;
            default:
                return `${data[3]['failed'] ? data[3]['failed'] : 'Failed'}`;
        }
    }

    switch (data[0]) {
        case -1:
            return `${data[3] && data[3]['failed'] ? data[3]['failed'] : 'Failed'}`;
        case 0:
            return `${data[3] && data[3]['ready'] ? data[3]['ready'] : 'Ready'}`;
        case 1:
            return `${data[3] && data[3]['in_progress'] ? data[3]['in_progress'] : 'In progress'}`;
        case 2:
            return `${data[3] && data[3]['generated'] ? data[3]['generated'] : 'Generated'}`;
        default:
            return `${data[3] && data[3]['failed'] ? data[3]['failed'] : 'Failed'}`;
    }
}

export const getDiagnoseReportStatus = (...data) => {
    if (typeof data[1] !== 'undefined' && data[1] === 'forStyle') {
        switch (data[0]) {
            case 'notGenerated':
                return 'notGenerated';
            case 'pending':
                return 'Pending';
            case 'generated':
                return 'Generated';
            case 'Failed':
                return 'Failed';
            case 'Aborted':
                return 'Aborted'
            default:
                return 'Failed';
        }
    }
    if (!(data[1] && data[2])) {
        switch (data[0]) {
            case 'notGenerated':
                return `Not generated`;
            case 'pending':
                return `In progress`;
            case 'generated':
                return `Generated`;
            case 'Failed':
                return `Failed`;
            case 'Aborted':
                return `Aborted by user`;
            default:
                return `Failed`;
        }
    }

    switch (data[0]) {
        case 'notGenerated':
            return `${data[1]} / ${data[2]} Not generated`;
        case 'pending':
            return `${data[1]} / ${data[2]} In progress`;
        case 'generated':
            return `${data[1]} / ${data[2]} Generated`;
        case 'Failed':
            return `${data[1]} / ${data[2]} Failed`;
        case 'Aborted':
            return `${data[1]} / ${data[2]} Aborted by user`;
        default:
            return `${data[1]} / ${data[2]} Failed`;
    }
}

export const jsonPrettyPrint = jsonData => {
    let parsedObject = jsonData ? JSON.parse(jsonData) : {};
    let prettyPrint = Object.keys(parsedObject).map(key => {
        return <p key={`${key}_${Math.random() * 100}`} style={{ padding: 0, margin: 0 }}>{`${key}: ${parsedObject[key]}`}</p>;
    });
    return prettyPrint;
};

export const getServerStatus = (status, translations) => {
    switch (status) {
        case 0:
            return translations ? translations['offline'] || 'Offline' : 'Offline';
        case 1:
            return translations ? translations['online'] || 'Online' : 'Online';
        default:
            return translations ? translations['offline'] || 'Offline' : 'Offline';
    }
}
export const blockInvalidChar = e => ['e', 'E', '+', '-'].includes(e.key) && e.preventDefault();

export const parseURL = url => {
    let query = url.split('?');
    if (query.length === 1) {
        return null;
    }
    let queryData = query[1];
    if (queryData.includes('&')) {
        queryData = [...queryData.split('&')];
    } else {
        queryData = [queryData]
    }

    let obj = {};
    for (var data of queryData) {
        let splitByEqual = data.split('=');
        obj[splitByEqual[0]] = splitByEqual[1];
    }
    return obj;
}

export const checkIfLoading = (loading) => {
    return !!(Object.keys(loading).find((key) => loading[key] === true));
}

export const includes = (permissions, includedPermissions) => {
    return includedPermissions.includes(permissions);
}

export const updateURL = async newTabValue => {
    let newUrl = window.location.href.split('#')[0];
    window.history.replaceState({ path: `${newUrl}#${newTabValue}` }, '', `${newUrl}#${newTabValue}`);
}

export const downloadFile = (data, fileName) => {
    const objectURL = URL.createObjectURL(data);
    const downloadElement = document.createElement('a');
    downloadElement.href = objectURL;
    downloadElement.download = `${fileName}`;
    return downloadElement.click();
}

export const createHistory = (preserveHash) => {
    let pathName = window.location.pathname;
    let search = window.location.search;
    let hash = window.location.hash;
    let backRoute = `${pathName}${search ? search : ''}${preserveHash ? hash : ''}`;
    History.push(backRoute);
}

export const BackButton = (translations, customTooltip = null) => {

    return <Tooltip className={customTooltip} title={translations['go_back'] || "Go back"}>
        <IconButton aria-label={translations['go_back'] || "Go back"} onClick={() => { History.goBack() }}>
            <ArrowBack />
        </IconButton>
    </Tooltip>
}

export const exampleValues = `
<div dir="ltr">
Examples:
<p class="MsoNormal" style="font-size:11pt;font-family:Calibri,sans-serif"><b><span lang="EN-US" style="font-size:10.5pt;font-family:&quot;Segoe UI&quot;,sans-serif;color:rgb(125,197,227);letter-spacing:-0.05pt">Installation</b></p>
<p class="MsoNormal" style="font-size:11pt;font-family:Calibri,sans-serif">For a more smooth installation process we sign the Installer with a SSL certificate.</p>
<p class="MsoNormal" style="font-size:11pt;font-family:Calibri,sans-serif"><b><span lang="EN-US" style="font-size:10.5pt;font-family:&quot;Segoe UI&quot;,sans-serif;color:rgb(125,197,227);letter-spacing:-0.05pt">Erasure</b></p>
<p class="MsoNormal" style="font-size:11pt;font-family:Calibri,sans-serif">The erasure process was improved to handle more easily multiple parallel iOS erasures.</p>
<p class="MsoNormal" style="font-size:11pt;font-family:Calibri,sans-serif"><b><span lang="EN-US" style="font-size:10.5pt;font-family:&quot;Segoe UI&quot;,sans-serif;color:rgb(125,197,227);letter-spacing:-0.05pt">Notifications</b><b><span lang="EN-US" style="font-size:10.5pt;font-family:&quot;Segoe UI&quot;,sans-serif;color:rgb(229,35,30);letter-spacing:-0.05pt"></b></p>
<p class="MsoNormal" style="font-size:11pt;font-family:Calibri,sans-serif">The notification system was revamped to provide easy access to all notifications.</p>
<p class="MsoNormal" style="font-size:11pt;font-family:Calibri,sans-serif"><b><span lang="EN-US" style="font-size:10.5pt;font-family:&quot;Segoe UI&quot;,sans-serif;color:rgb(125,197,227);letter-spacing:-0.05pt">Proxy Support</b></p>
<p class="MsoNormal" style="font-size:11pt;font-family:Calibri,sans-serif">To provide full flexibility many proxy settings where implemented.</p>
<p class="MsoNormal" style="font-size:11pt;font-family:Calibri,sans-serif">Additionally proxy support can be granular activated for Firmware-Download and/or Factory Reset.</p></div>
`;

export const copyToClipBoard = (text) => {
    var dummy = document.createElement("input");
    document.body.appendChild(dummy);
    dummy.setAttribute('value', text);
    dummy.select();
    document.execCommand("copy");
    document.body.removeChild(dummy);
}

export const isValidJson = text => {
    try {
        JSON.parse(text);
        return true;
    } catch (error) {
        return false;
    }
}

export const isValidMapping = text => {
    if (!isValidJson(text)) {
        return false;
    }
    const tableMappingObj = JSON.parse(text);
    const firstKey = Object.keys(tableMappingObj)[0];
    if ((tableMappingObj?.PCProduct && tableMappingObj?.MobileProduct && tableMappingObj?.StorageProduct && tableMappingObj?.DisplayProduct) || (tableMappingObj?.[firstKey]?.PCProduct && tableMappingObj?.[firstKey]?.MobileProduct && tableMappingObj?.[firstKey]?.StorageProduct && tableMappingObj?.[firstKey]?.DisplayProduct)) {
        return true;
    }
    return false;
}

export const isValidRegex = text => {
    try {
        new RegExp(text);
        return true;
    } catch (error) {
        return false;
    }
};

export const isValidHex = number => {
    let parsedHex = parseInt(number, 16);
    return (parsedHex.toString(16).length % 2 === 0 ? parsedHex.toString(16) : `0${parsedHex.toString(16)}`) === number.toLowerCase();
}

export const toHex = number => {
    return (Number(number)
        .toString(16).length % 2 === 0 ? Number(number).toString(16) : `0${Number(number).toString(16)}`)
        .toUpperCase();
};

export const hexToDec = number => {
    return parseInt(number, 16);
};

export const safeParse = text => {
    try {
        const parsed = JSON.parse(text);
        return parsed;
    } catch (error) {
        return null;
    }
}

export const capitalize = (s) => {
    if (typeof s !== 'string') return ''
    return s.charAt(0).toUpperCase() + s.slice(1)
}
